<template>
  <v-progress-circular :size="100" :width="7" indeterminate color="blue-grey darken-2">Loading </v-progress-circular>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LoadingIndicator'
});
</script>
